module.exports = __webpack_public_path__ + "static/media/file-type.792c2f69.svg";